/* Beanie Boos – "Add a little friend" row in the bag drawer.
   The row is rendered by sections/bb-bag-addons.liquid (via /?section_id=bb-bag-addons) and slotted
   under the bag items each time the drawer changes, so Rise's own cart-drawer file stays untouched.
   Buttons add the item at full price and redraw the drawer in place. */
(function () {
  if (window.bbAddonsReady) return;
  window.bbAddonsReady = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var timer = null;
  var busy = false;
  var lastKey = '';
  var lastHtml = '';

  function drawer() { return document.querySelector('cart-drawer'); }

  function slotAfter() {
    var d = drawer();
    return d && d.querySelector('.drawer__cart-items-wrapper');
  }

  function cartKey() {
    var rows = document.querySelectorAll('cart-drawer .cart-item');
    var k = [];
    rows.forEach(function (r) {
      var q = r.querySelector('.quantity__input');
      k.push((q && q.getAttribute('data-quantity-variant-id')) + 'x' + (q && q.value));
    });
    return k.join('|');
  }

  function put(html) {
    var anchor = slotAfter();
    if (!anchor) return;
    var slot = anchor.parentNode.querySelector('.bb-addons-slot');
    if (!slot) {
      slot = document.createElement('div');
      slot.className = 'bb-addons-slot';
      anchor.insertAdjacentElement('afterend', slot);
    }
    if (slot.innerHTML !== html) slot.innerHTML = html;
  }

  function refresh() {
    var anchor = slotAfter();
    if (!anchor || busy) return;
    var key = cartKey();
    if (key && key === lastKey) { put(lastHtml); return; }
    busy = true;
    fetch(root + '?section_id=bb-bag-addons', { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var row = doc.querySelector('.bb-addons');
        lastHtml = row ? row.outerHTML : '';
        lastKey = key;
        put(lastHtml);
      })
      .catch(function () {})
      .finally(function () { busy = false; if (cartKey() !== lastKey) schedule(); });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 120);
  }

  function watch() {
    var d = drawer();
    if (!d) return;
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var t = records[i].target;
        if (t.closest && (t.closest('.bb-addons-slot') || t.closest('.bb-fs'))) continue;
        var added = records[i].addedNodes;
        if (added.length === 1 && added[0].classList && added[0].classList.contains('bb-addons-slot')) continue;
        schedule();
        return;
      }
    }).observe(d, { childList: true, subtree: true });
    schedule();
  }

  /* Add buttons */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-bb-addon]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var d = drawer();
    var label = btn.querySelector('.bb-addon__add-label');
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    if (label) label.textContent = 'Adding';

    var body = { items: [{ id: Number(btn.getAttribute('data-bb-addon')), quantity: 1 }] };
    if (d && typeof d.getSectionsToRender === 'function') {
      body.sections = d.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          if (label) label.textContent = 'Sold out';
          return;
        }
        lastKey = '';
        if (d && typeof d.renderContents === 'function' && res.sections) {
          if (d.classList.contains('is-empty')) d.classList.remove('is-empty');
          d.renderContents(res);
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        if (label) label.textContent = 'Add';
      });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
